// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkspaceProfile__header-b25fc0 {
  display: flex;
  padding-inline-start: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-inline-end: 16px;
  gap: 16px;
}

.WorkspaceProfile__avatar-da29a2 {
  display: flex;
  align-items: flex-start;
}

.WorkspaceProfile__info-feef31 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-inline-end: 48px;
  gap: 4px;
}

.WorkspaceProfile__title-f49e3c {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--base-110);
  word-break: break-all;
}

.WorkspaceProfile__members-d64fb3 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-subtitle-4);
  color: var(--base-90);
}

.WorkspaceProfile__list-item-a651d9 {
  min-height: 48px;
  padding: 0 24px;
}

.WorkspaceProfile__list-item-title-c91e30 {
  margin-inline-start: 8px;
}

.WorkspaceProfile__list-icon-afbda1 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/WorkspaceProfile/WorkspaceProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EACA,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,4BAAA;EACA,sCAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".header {\n  display: flex;\n  padding-inline-start: 24px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  padding-inline-end: 16px;\n  gap: 16px;\n}\n\n.avatar {\n  display: flex;\n  align-items: flex-start;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-inline-end: 48px;\n  gap: 4px;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--base-110);\n  word-break: break-all;\n}\n\n.members {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-subtitle-4);\n  color: var(--base-90);\n}\n\n.list-item {\n  min-height: 48px;\n  padding: 0 24px;\n}\n\n.list-item-title {\n  margin-inline-start: 8px;\n}\n\n.list-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `WorkspaceProfile__header-b25fc0`,
	"avatar": `WorkspaceProfile__avatar-da29a2`,
	"info": `WorkspaceProfile__info-feef31`,
	"title": `WorkspaceProfile__title-f49e3c`,
	"members": `WorkspaceProfile__members-d64fb3`,
	"list-item": `WorkspaceProfile__list-item-a651d9`,
	"listItem": `WorkspaceProfile__list-item-a651d9`,
	"list-item-title": `WorkspaceProfile__list-item-title-c91e30`,
	"listItemTitle": `WorkspaceProfile__list-item-title-c91e30`,
	"list-icon": `WorkspaceProfile__list-icon-afbda1`,
	"listIcon": `WorkspaceProfile__list-icon-afbda1`
};
module.exports = ___CSS_LOADER_EXPORT___;
